import { Heading } from '@hawkins/components';
import { Grid } from 'src/domains/shared/components/Grid';

export const ResponsiveErrorState = () => {
  /**
   * TODO: change to use ErrorState once http://go/jira/browse/HAWK-849 is fixed.
   */
  return (
    <Grid gap="Space8" alignContent="center">
      <Heading level={3} align="center">
        Something went wrong..
      </Heading>
      <Heading level={0} align="center">
        Make sure the data provided is correct.
      </Heading>
    </Grid>
  );
};
